export const WEBSITE_TOKEN_COOKIE = 'website-token';
